module.exports = __webpack_public_path__ + "img/ssta_static.a2d290ea.png";